export const defaultIcon = 'rectangle';
export const defaultTypeToIconMap = {
    Alert: null,
    AlertTrigger: null,
    Area: null,
    BooleanRule: null,
    ComparisonRule: null,
    ControlEntity: null,
    Customer: null,
    Device: null,
    DeviceControlTransaction: null,
    DeviceHistory: null,
    DeviceMessage: null,
    DynamoDBTable: null,
    Entity: null,
    EntityNetwork: null,
    EntityProgramme: null,
    EntityProgrammeSet: null,
    EntityRollingProgramme: null,
    Gateway: null,
    GatewayConfig: null,
    GatewayData: null,
    Geofence: null,
    GeofenceRule: null,
    GeoModelCommon: null,
    GeoPoint: null,
    Group: null,
    Incident: null,
    LambdaFunction: null,
    LevelEntity: null,
    Location: null,
    LoRaWANApplicationServer: null,
    MetricRule: null,
    MobileDevice: null,
    MobileEntity: null,
    Notification: null,
    NotificationSubscription: null,
    OnDemandProgramme: null,
    OpenWeatherData: null,
    OperatingEntity: null,
    Organization: null,
    Path: null,
    Person: null,
    Place: null,
    PlaceStyler: null,
    ProductModel: null,
    Property: null,
    RangeEntity: null,
    Region: null,
    Ruleset: null,
    ScoreConfig: null,
    StationaryEntity: null,
    Supplier: null,
    Team: null,
    ThingShadowState: null,
    User: null,
    VideoHub: null,
    VideoStream: null,
    Partner: null,
};
